import { proxy, subscribe } from 'valtio';

import { getBoardIdFromUrlOrEnvironment } from './get-board-id-from-environment';
import { isLocalEAPDevMode } from './is-dev-mode';

const DEVLOOP_KEY = 'canvas-dev-loop';

export const currentDevelopmentUIState = proxy({
  accountId: process.env.VITE_CANVAS_EAP_ACCOUNT_ID ?? 'no-account-id',
  cloudId: process.env.VITE_CANVAS_EAP_CLOUD_ID ?? 'no-cloud-id',
  containerKey: process.env.VITE_CANVAS_EAP_CONTAINER_KEY ?? 'no-container-key',
  containerId: process.env.VITE_CANVAS_EAP_CONTAINER_ID ?? 'no-container-id',
  containerName: process.env.VITE_CANVAS_EAP_CONTAINER_NAME ?? 'no-container-name',
  boardId: getBoardIdFromUrlOrEnvironment(),
});

function getStoredDevelopmentState() {
  const storedDevelopmentState = globalThis.localStorage.getItem(DEVLOOP_KEY);
  if (storedDevelopmentState) {
    return JSON.parse(storedDevelopmentState) as typeof currentDevelopmentUIState;
  }
}

export const setupDevelopmentUIState = () => {
  const initialDevelopmentState = getStoredDevelopmentState();

  if (initialDevelopmentState) {
    currentDevelopmentUIState.accountId = initialDevelopmentState.accountId;
    currentDevelopmentUIState.cloudId = initialDevelopmentState.cloudId;
    currentDevelopmentUIState.containerKey = initialDevelopmentState.containerKey;
    currentDevelopmentUIState.containerId = initialDevelopmentState.containerId;
    currentDevelopmentUIState.containerName = initialDevelopmentState.containerName;
    currentDevelopmentUIState.boardId = initialDevelopmentState.boardId;
  }

  subscribe(currentDevelopmentUIState, () => {
    localStorage.setItem(DEVLOOP_KEY, JSON.stringify(currentDevelopmentUIState));
  });
};

if (isLocalEAPDevMode()) {
  setupDevelopmentUIState();
}
